import Cookies from 'js-cookie';

const keys = {
  TOKEN: 'token',
  CRM_TOKEN: 'crm_token',
};

export const getToken = () => Cookies.get(keys.TOKEN);
export const getCrmToken = () => Cookies.get(keys.CRM_TOKEN);
